import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="os-table-wrap">
          <table className="table os-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Method</th>
                <th scope="col">Note</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="os-empty">
                    <EmptyState>No entries for this month.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((expense, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{expense.date}</td>
                    <td>
                      <span className="os-badge">{expense.subCategory}</span>
                    </td>
                    <td>{expense.note}</td>
                    <td>
                      <span className="os-amount-pill">{expense.amount}Tk</span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
